<script>
  import Skeleton from '@/components/Skeleton'

  export default {
    components: {
      Skeleton
    }
  }
</script>

<template>
  <div>
    <div class="container px-4 lg:px-8 my-10 md:mb-30 md:mt-7">
      <div class="md:px-8 pt-2">
        <Skeleton class="h-6 w-75" />
      </div>
      <div class="product-detail-grid mt-4">
        <div class="row-start-2 sm:row-start-1 sm:row-end-3 col-span-1">
          <div class="flex justify-center md:mt-30 md:mb-40">
            <Skeleton class="h-96 w-75" />
          </div>
          <div class="flex justify-center mt-8">
            <Skeleton class="h-6 w-52" />
          </div>
        </div>

        <div class="row-start-1 row-end-2 col-span-1 row-span-1 lg:pt-30">
          <Skeleton class="h-8 w-full" />
          <Skeleton class="mt-4 h-4 w-full" />
          <Skeleton class="mt-2 h-4 w-3/4" />
        </div>

        <div class="row-start-3 row-end-4 sm:row-start-2 sm:row-end-3">
          <div class="flex space-y-6 lg:space-x-14 lg:space-y-0 lg:items-center flex-col lg:flex-row">
            <div class="flex flex-row  space-x-4 lg:space-x-0 lg:flex-col">
              <Skeleton class="h-8 w-20" />
              <Skeleton class="mt-2 h-6 w-28" />
            </div>
            <Skeleton class="h-12 w-full md:w-40 rounded" />
          </div>
          <div class="mt-6">
            <Skeleton class="h-4 w-1/2" />
            <Skeleton class="mt-2 h-4 w-2/5" />

            <div class="mt-8">
              <Skeleton class="h-6 w-1/3" />
              <ul class="flex space-x-2 mt-4">
                <li
                  v-for="i in 3"
                  :key="i"
                  class=""
                >
                  <Skeleton class="h-18 w-18 rounded-4" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="max-w-148 mx-auto py-16 sm:my-20 space-y-16 sm:space-y-20">
        <div class="space-y-2">
          <Skeleton class="h-8 mb-5 w-full" />
          <Skeleton class="h-2 w-4/6" />
          <Skeleton class="h-2 w-3/5" />
          <Skeleton class="h-2 w-1/4" />
          <Skeleton class="h-2 w-4/5" />
          <Skeleton class="h-2 w-4/6" />
          <Skeleton class="h-2 w-5/6" />
          <Skeleton class="h-2 w-6/6" />
          <Skeleton class="h-2 w-2/6" />
          <Skeleton class="h-2 w-3/4" />
          <Skeleton class="h-2 w-5/6" />
          <Skeleton class="h-2 w-4/5" />
        </div>
        <div class="w-full">
          <div class="w-full flex justify-center mb-6">
            <Skeleton class="h-8 w-1/2" />
          </div>
          <table>
            <tbody>
              <tr>
                <td><Skeleton class="h-4 w-3/6" /></td>
                <td> <Skeleton class="h-4 w-2/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-4/6" /></td>
                <td> <Skeleton class="h-4 w-1/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-2/6" /></td>
                <td> <Skeleton class="h-4 w-3/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-5/6" /></td>
                <td> <Skeleton class="h-4 w-4/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-3/6" /></td>
                <td> <Skeleton class="h-4 w-2/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-4/6" /></td>
                <td> <Skeleton class="h-4 w-1/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-2/6" /></td>
                <td> <Skeleton class="h-4 w-3/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-5/6" /></td>
                <td> <Skeleton class="h-4 w-4/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-3/6" /></td>
                <td> <Skeleton class="h-4 w-2/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-4/6" /></td>
                <td> <Skeleton class="h-4 w-1/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-2/6" /></td>
                <td> <Skeleton class="h-4 w-3/6" /></td>
              </tr>
              <tr>
                <td><Skeleton class="h-4 w-5/6" /></td>
                <td> <Skeleton class="h-4 w-4/6" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.product-detail-grid {
  @apply grid grid-cols-1 grid-rows-3 gap-x-8 gap-y-14 grid-rows-max;
  @screen sm {
    @apply grid-cols-2 grid-rows-2;
  }
  grid-template-rows: auto 1fr !important;
}

table {
  @apply w-full;
  tr {
    @apply border-t border-b border-gray-100;
    td {
      @apply py-2;
      @apply leading-relaxed;
    }
  }
}
</style>
